import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-esign-web-view',
  templateUrl: './esign-web-view.component.html',
  styleUrls: ['./esign-web-view.component.scss']
})
export class EsignWebViewComponent implements AfterViewInit, OnDestroy {
  @ViewChild('iframe') iframe!: ElementRef;
  interval:any;
  @Input() url:any = '';
  @Input() id:string = '';
  @Output() userEsigned:EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private util:UtilService){}
  ngAfterViewInit(): void {
    document.querySelector('.landing-content')?.scroll(0, 0);
    const d:any = document.querySelector('.landing-content');
   d && (d.style.overflow = 'scroll');
    this.iframe.nativeElement.src =this.url.changingThisBreaksApplicationSecurity;
    this.startTimer();
  }

  
  startTimer(){
    clearTimeout(this.interval);
    this.util.updateESigned(false).then(()=>{
      const signer =  this.util.loanDetails.eSignStatusModel.signerDetails.find((signer:any)=> signer.signerRefId === this.id);
      if(signer?.signed){
          this.userEsigned.emit(true);
          this.util.cleverTapEventCall(CleverTapConstents.application_form_Esign_success,{
            'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
            'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
          });
      }else{
        this.interval = setTimeout(() => {
          this.startTimer();
        }, 1000);
      }
    }).catch(()=>{
      this.util.cleverTapEventCall(CleverTapConstents.application_form_Esign_failure,{
        applicantType: this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });

    });
  }
  
  ngOnDestroy(): void {
    clearTimeout(this.interval);
    const d:any = document.querySelector('.landing-content');
   d && (d.style.overflow = 'auto') && (d.style.overflowX = 'hidden');
  }
}


